<template>
    <b-dropdown id="dropdown-1" class="bg-transparent">
        <template v-slot:button-content>
            <img height="20" :src="`${publicPath}langs/${currentLanguage}.svg`" :alt="currentLanguage">
        </template>
        <b-dropdown-item v-for="lang in supportedLanguages" :active="isCurrentLanguage(lang)" @click="changeLanguage(lang)" :key="lang">
            <img height="20" :src="`${publicPath}langs/${lang}.svg`" :alt="lang">
        </b-dropdown-item>
    </b-dropdown>
</template>
<script>
    import { Trans } from '@/plugins/Translation'
    export default {
        data() {
            return {
                publicPath: process.env.BASE_URL
            }
        },
        computed: {
            supportedLanguages () {
                return Trans.supportedLanguages
            },
            currentLanguage () {
                return Trans.currentLanguage
            }
        },
        methods: {
            changeLanguage (lang) {
                const to = this.$router.resolve({ params: { lang } })
                return Trans.changeLanguage(lang).then(() => {
                    this.$router.push(to.location)
                })
            },
            isCurrentLanguage (lang) {
                return lang === this.currentLanguage
            }
        }
    }
</script>
